import { useState } from "react";
import { Play } from "lucide-react";

/**
 * Lightweight YouTube embed:
 *  - Shows a thumbnail + play button
 *  - Swaps to a real <iframe> on click (autoplays)
 * Uses YouTube's standard thumbnail endpoints with graceful fallback.
 */
export default function LiteYouTube({
  videoId,
  title,
  className = "",
  overlay,
}) {
  const [playing, setPlaying] = useState(false);
  const [imgIdx, setImgIdx] = useState(0);
  const sources = [
    `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`,
    `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
    `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
    `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`,
  ];

  if (playing) {
    return (
      <iframe
        title={title}
        className={`absolute inset-0 w-full h-full ${className}`}
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
        allow="autoplay; encrypted-media; picture-in-picture; web-share"
        allowFullScreen
        frameBorder="0"
      />
    );
  }

  return (
    <button
      type="button"
      aria-label={`Play ${title}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setPlaying(true);
      }}
      className={`absolute inset-0 w-full h-full group ${className}`}
    >
      <img
        src={sources[imgIdx]}
        alt={title}
        loading="lazy"
        onError={() => {
          if (imgIdx < sources.length - 1) setImgIdx(imgIdx + 1);
        }}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent pointer-events-none" />
      {overlay}
      <span className="absolute inset-0 grid place-items-center pointer-events-none">
        <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/95 text-[#1C1C1A] grid place-items-center shadow-2xl transition-transform duration-500 group-hover:scale-110">
          <Play size={22} className="translate-x-[2px]" />
        </span>
      </span>
    </button>
  );
}
